var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "office-search-results-item" }, [
    _c("p", { staticClass: "office-search-results-item-title" }, [
      _vm._v("Interim HealthCare of " + _vm._s(_vm.officeName))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "office-search-results-item-ctas" }, [
      _c(
        "a",
        {
          staticClass: "office-search-results-item-external",
          attrs: { target: "_blank", href: _vm.item.CareersCtaLink },
          on: {
            click: function($event) {
              return _vm.pushDatalayer(_vm.item)
            }
          }
        },
        [_vm._v("View Jobs")]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "office-search-results-item-separator" }, [
        _vm._v("|")
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "office-search-results-item-info ",
          attrs: { href: "" + _vm.item.Url },
          on: {
            click: function($event) {
              return _vm.pushDatalayer(_vm.item)
            }
          }
        },
        [_vm._v("Office Information")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }